define(function() {
  'use strict';

  /**
   * Increments the minor version and returns the new version string.
   *
   * @param  {String} _version app version
   *
   * @return {String} returns incremented version
   */
  var inc = function incrementVersion(_version) {
    var lastNumericRegex = /([^\D]+)$/;
    var matches = lastNumericRegex.exec(_version);

    if (matches && matches.length > 0 !== null) {
      var minorVersion = parseInt(matches[1], 10) + 1;
      return _version.replace(lastNumericRegex, minorVersion);
    }

    return _version;
  };

  /**
   * returns a negative integer, zero, or a positive integer as the first argument
   * is less than, equal to, or greater than the second.
   *
   * @param  {String} _version1 version number to compare
   * @param  {String} _version2 version number to compare
   *
   * @return {number} returns -1 if less, 0 if equal and 1 if greater
   */
  var compare = function compareVersion(_version1, _version2) {
    var EQUAL = 0;
    var GREATER = 1;
    var LESS = -1;

    if (_version1 === _version2) {
      return EQUAL;
    }

    var nonNumericRegex = /(\D)/g;
    var v1Array = _version1.split(nonNumericRegex);
    var v2Array = _version2.split(nonNumericRegex);

    if (v1Array.length > v2Array.length) {
      return GREATER;
    } else if (v1Array.length < v2Array.length) {
      return LESS;
    }

    for (var i = 0; i < v1Array.length; i++) {
      if (parseInt(v1Array[i], 10) > parseInt(v2Array[i], 10)) {
        return GREATER;
      } else if (parseInt(v1Array[i], 10) < parseInt(v2Array[i], 10)) {
        return LESS;
      }
    }
  };

  return {
    inc: inc,
    compare: compare
  };
});
